// AI Generated Component
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { ComponentDetailsViewService } from '@client/app/blocks/service/component-details-view.service';

@Component({
    selector: 'url-title-document-details',
    standalone: false,
    template: `
        <url-title [title]="title" (goTo)="openDocumentDetails()" [active]="active" [url]="url"></url-title>
    `,
})
export class UrlTitleDocumentDetailsComponent implements OnInit {
    @Input() active?: boolean;
    @Input() target?: string | undefined;
    @Input() subTarget?: string | null | undefined;
    @Input() document?: any;
    @Input() title?: string;
    @Input() url?: string | undefined;

    @Output() onClose = new EventEmitter<any>();

    constructor (
        private componentDetailsViewService: ComponentDetailsViewService,
    ) {}

    ngOnInit (): void {
        this.subTarget = this.subTarget || null;
    }

    openDocumentDetails (): void {
        const params = {
            target: this.target,
            subTarget: this.subTarget,
        };

        this.componentDetailsViewService.goToDocumentDetails(this.document, params, this.onClose.observers.length > 0 ? () => this.onClose.emit() : undefined);
    }
}
